export interface VideoItem {
  id: string;
  title: string;
  categorySlug: string;
  coverImage: string;
  year: number;
  duration: string;
  rating: number;
  description: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
}

export const videos: VideoItem[] = [
  {
    id: 'v-1',
    title: '战狼3：终极使命',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20action%20movie%20poster%20with%20soldier%20silhouette%20against%20fiery%20explosion%20background%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20minimalist%20design%20with%20bold%20typography%20space&width=800&height=1120&seq=movie-action-01&orientation=portrait',
    year: 2025,
    duration: '128分钟',
    rating: 8.7,
    description: '顶尖特种兵冷锋再次临危受命，前往战乱地区执行一项几乎不可能完成的营救任务。面对重重险境，他凭借超凡的战斗技能和坚定的信念，谱写了一曲热血澎湃的英雄赞歌。',
    isHot: true,
    isNew: true,
    views: 1258000,
  },
  {
    id: 'v-2',
    title: '流浪地球3：星际远征',
    categorySlug: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20deep%20space%2C%20distant%20galaxy%20and%20nebula%20background%2C%20cinematic%20lighting%2C%20cool%20silver%20and%20teal%20tones%2C%20clean%20composition%20with%20title%20space&width=800&height=1120&seq=movie-scifi-01&orientation=portrait',
    year: 2025,
    duration: '155分钟',
    rating: 9.1,
    description: '人类在浩瀚宇宙中继续寻找新的家园，面对未知的外星文明和宇宙级的灾难，人类命运共同体的抉择牵动着每一个人的心。',
    isHot: true,
    isNew: true,
    views: 2380000,
  },
  {
    id: 'v-3',
    title: '夏洛特烦恼2',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20funny%20expression%20character%20in%20school%20uniform%2C%20bright%20colorful%20background%20with%20confetti%2C%20warm%20lighting%2C%20playful%20atmosphere%2C%20clean%20design%20with%20bold%20title%20area&width=800&height=1120&seq=movie-comedy-01&orientation=portrait',
    year: 2025,
    duration: '115分钟',
    rating: 8.4,
    description: '夏洛再次穿越回到高中时代，这一次他决定不再重复过去的错误。然而命运似乎总喜欢开玩笑，一场更加荒诞离奇的喜剧之旅就此展开。',
    isHot: true,
    isNew: false,
    views: 1890000,
  },
  {
    id: 'v-4',
    title: '前任4：英年早婚',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20movie%20poster%20with%20couple%20silhouette%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20golden%20sunset%20background%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20clean%20title%20area&width=800&height=1120&seq=movie-romance-01&orientation=portrait',
    year: 2025,
    duration: '122分钟',
    rating: 7.9,
    description: '孟云和余飞各自步入了婚姻的殿堂，却发现婚后的生活并非想象中那般美好。在理想与现实的夹缝中，他们该如何守护自己的爱情？',
    isHot: false,
    isNew: true,
    views: 1560000,
  },
  {
    id: 'v-5',
    title: '深海巨兽',
    categorySlug: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20monster%20movie%20poster%20with%20giant%20sea%20creature%20shadow%20underwater%2C%20deep%20ocean%20blue%20background%2C%20mysterious%20atmosphere%2C%20dramatic%20lighting%20from%20above%2C%20cinematic%20composition%2C%20clean%20title%20space&width=800&height=1120&seq=movie-scifi-02&orientation=portrait',
    year: 2024,
    duration: '134分钟',
    rating: 7.8,
    description: '深海科考队在太平洋深处发现了未知的巨大生物，随着探索的深入，他们逐渐揭开了隐藏在深海中的惊天秘密。一场关乎人类存亡的危机正在逼近。',
    isHot: true,
    isNew: false,
    views: 987000,
  },
  {
    id: 'v-6',
    title: '午夜凶铃·重生',
    categorySlug: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%20with%20eerie%20female%20figure%20in%20white%20dress%2C%20dark%20misty%20forest%20background%2C%20cold%20blue%20moonlight%2C%20atmospheric%20and%20mysterious%2C%20film%20grain%20effect%2C%20clean%20title%20area&width=800&height=1120&seq=movie-horror-01&orientation=portrait',
    year: 2024,
    duration: '108分钟',
    rating: 7.5,
    description: '一段被封存多年的录像带再次出现，凡是看过它的人都会在七天后离奇死亡。年轻的记者调查此事，却发现自己已经陷入了无法逃脱的诅咒之中。',
    isHot: false,
    isNew: false,
    views: 756000,
  },
  {
    id: 'v-7',
    title: '哪吒之魔童降世2',
    categorySlug: 'anime',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20boy%20warrior%20with%20flaming%20hair%2C%20dramatic%20sky%20with%20thunder%20and%20fire%2C%20epic%20fantasy%20style%2C%20vibrant%20red%20and%20gold%20colors%2C%20clean%20title%20space&width=800&height=1120&seq=movie-anime-01&orientation=portrait',
    year: 2025,
    duration: '118分钟',
    rating: 9.3,
    description: '哪吒在战胜天劫之后，面临着更加严峻的考验。天庭的秩序与人间的情义之间，他必须做出自己的选择。一场震撼三界的大战即将爆发。',
    isHot: true,
    isNew: true,
    views: 3120000,
  },
  {
    id: 'v-8',
    title: '封神第二部：战火西岐',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20warrior%20in%20armor%2C%20massive%20battlefield%20with%20flaming%20arrows%2C%20dramatic%20stormy%20sky%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20composition%2C%20clean%20title%20area&width=800&height=1120&seq=movie-action-02&orientation=portrait',
    year: 2025,
    duration: '148分钟',
    rating: 8.9,
    description: '殷商大军压境西岐，姜子牙率领众将奋力抵抗。神魔大战一触即发，封神榜的争夺战进入了白热化阶段。',
    isHot: true,
    isNew: true,
    views: 2650000,
  },
  {
    id: 'v-9',
    title: '你好，李焕英2',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20family%20comedy%20movie%20poster%20with%20mother%20and%20daughter%20laughing%20together%2C%20warm%20nostalgic%201980s%20China%20background%2C%20soft%20golden%20light%2C%20heartwarming%20atmosphere%2C%20clean%20title%20area&width=800&height=1120&seq=movie-comedy-02&orientation=portrait',
    year: 2025,
    duration: '132分钟',
    rating: 8.6,
    description: '贾晓玲又一次获得了穿越时空的机会，这一次她决心让母亲过上完全不一样的人生。然而在改变命运的过程中，她发现了母亲深藏心底的秘密。',
    isHot: false,
    isNew: true,
    views: 1720000,
  },
  {
    id: 'v-10',
    title: '三体·黑暗森林',
    categorySlug: 'scifi',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20hard%20sci-fi%20movie%20poster%20with%20cosmic%20dark%20forest%20concept%2C%20stars%20and%20mysterious%20alien%20signal%2C%20deep%20space%20background%2C%20philosophical%20and%20cold%20atmosphere%2C%20minimalist%20design%2C%20clean%20title%20space&width=800&height=1120&seq=movie-scifi-03&orientation=portrait',
    year: 2025,
    duration: '160分钟',
    rating: 9.5,
    description: '面壁者罗辑发现了宇宙的黑暗森林法则，在与三体文明的博弈中，他以一己之力为人类文明争取到了宝贵的喘息之机。',
    isHot: true,
    isNew: true,
    views: 4560000,
  },
  {
    id: 'v-11',
    title: '误杀3',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20man%20hiding%20in%20shadows%2C%20rainy%20night%20cityscape%20background%2C%20neon%20reflections%2C%20tense%20atmosphere%2C%20dark%20and%20moody%20tones%2C%20clean%20title%20space&width=800&height=1120&seq=movie-action-03&orientation=portrait',
    year: 2024,
    duration: '126分钟',
    rating: 8.2,
    description: '一位普通的父亲为了保护家人，精心策划了一场完美犯罪。然而当真相一层层被揭开，所有人都陷入了意想不到的境地。',
    isHot: false,
    isNew: false,
    views: 1340000,
  },
  {
    id: 'v-12',
    title: '百妖谱·京都篇',
    categorySlug: 'anime',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20beautiful%20fox%20spirit%20girl%20in%20traditional%20hanfu%2C%20ancient%20Chinese%20city%20at%20night%20with%20lanterns%2C%20mystical%20atmosphere%2C%20soft%20glowing%20lights%2C%20fantasy%20style%2C%20clean%20title%20space&width=800&height=1120&seq=movie-anime-02&orientation=portrait',
    year: 2025,
    duration: '105分钟',
    rating: 8.8,
    description: '桃夭带着磨牙和小和尚一路来到京都，这里百妖横行，每一只妖怪背后都藏着一个不为人知的动人故事。',
    isHot: false,
    isNew: true,
    views: 892000,
  },
  {
    id: 'v-13',
    title: '志愿军：存亡之战',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20charging%20on%20battlefield%2C%20smoke%20and%20dust%2C%20dramatic%20sky%2C%20heroic%20composition%2C%20muted%20olive%20and%20khaki%20tones%2C%20clean%20title%20space&width=800&height=1120&seq=movie-action-04&orientation=portrait',
    year: 2024,
    duration: '145分钟',
    rating: 9.0,
    description: '抗美援朝战争中最为惨烈的战役之一，志愿军将士以钢铁般的意志和血肉之躯，谱写了感天动地的英雄史诗。',
    isHot: false,
    isNew: false,
    views: 2100000,
  },
  {
    id: 'v-14',
    title: '我和我的父辈2',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20patriotic%20comedy%20movie%20poster%20with%20multiple%20generations%20of%20Chinese%20family%2C%20bright%20sunny%20day%2C%20warm%20nostalgic%20colors%2C%20uplifting%20atmosphere%2C%20clean%20title%20area&width=800&height=1120&seq=movie-comedy-03&orientation=portrait',
    year: 2025,
    duration: '138分钟',
    rating: 8.0,
    description: '四个不同年代的父辈故事，展现了普通中国家庭的欢笑与泪水。从改革开放到新时代，父辈们用他们的方式诠释了爱与责任。',
    isHot: false,
    isNew: false,
    views: 1120000,
  },
  {
    id: 'v-15',
    title: '大鱼海棠2',
    categorySlug: 'anime',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%20with%20flying%20dolphin%20and%20girl%20in%20magical%20underwater%20world%2C%20ethereal%20blue%20and%20gold%20light%2C%20dreamlike%20atmosphere%2C%20beautiful%20composition%2C%20clean%20title%20space&width=800&height=1120&seq=movie-anime-03&orientation=portrait',
    year: 2025,
    duration: '112分钟',
    rating: 8.3,
    description: '椿在掌管海棠花之后，遇到了新的挑战。海底世界的平衡被打破，她必须踏上一段新的旅程来拯救自己的家园。',
    isHot: false,
    isNew: true,
    views: 678000,
  },
  {
    id: 'v-16',
    title: '默杀',
    categorySlug: 'horror',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20psychological%20thriller%20movie%20poster%20with%20dark%20school%20corridor%2C%20mysterious%20shadow%20figure%2C%20dim%20flickering%20light%2C%20unsettling%20atmosphere%2C%20cold%20greenish%20tones%2C%20clean%20title%20area&width=800&height=1120&seq=movie-horror-02&orientation=portrait',
    year: 2024,
    duration: '119分钟',
    rating: 7.6,
    description: '一所女子中学接连发生学生失踪事件，校园里弥漫着恐惧的气息。新来的女教师发现，沉默的背后隐藏着令人震惊的真相。',
    isHot: false,
    isNew: false,
    views: 543000,
  },
  {
    id: 'v-17',
    title: '长相思',
    categorySlug: 'tv-series',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20beautiful%20woman%20in%20ancient%20hanfu%20dress%2C%20traditional%20Chinese%20palace%20background%2C%20soft%20golden%20light%2C%20romantic%20atmosphere%2C%20elegant%20composition%2C%20clean%20title%20space&width=800&height=1120&seq=movie-tv-01&orientation=portrait',
    year: 2025,
    duration: '45集',
    rating: 8.5,
    description: '上古时期，人神妖混居。皓翎国王姬玖瑶流落民间，历经百年颠沛之苦，在命运的安排下与四位男主相遇，展开了一段跨越千年的虐恋传奇。',
    isHot: true,
    isNew: true,
    views: 5670000,
  },
  {
    id: 'v-18',
    title: '庆余年2',
    categorySlug: 'tv-series',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20scholar%20in%20ancient%20robe%2C%20palace%20intrigue%20theme%2C%20ink%20wash%20painting%20style%20background%2C%20dramatic%20lighting%2C%20elegant%20composition%2C%20clean%20title%20space&width=800&height=1120&seq=movie-tv-02&orientation=portrait',
    year: 2024,
    duration: '36集',
    rating: 9.2,
    description: '范闲在经历了朝堂风波后，势力日益壮大。然而更大的阴谋在暗中酝酿，关于他身世的秘密也逐渐浮出水面。',
    isHot: true,
    isNew: false,
    views: 8200000,
  },
  {
    id: 'v-19',
    title: '奔跑吧·生态篇',
    categorySlug: 'variety',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20in%20nature%2C%20bright%20sunny%20outdoor%20scene%2C%20colorful%20energetic%20vibe%2C%20fun%20atmosphere%2C%20clean%20title%20area&width=800&height=1120&seq=movie-variety-01&orientation=portrait',
    year: 2025,
    duration: '12期',
    rating: 7.8,
    description: '跑男团再次集结，这一次他们走进大自然，开启一场生态环保主题的冒险之旅。爆笑游戏与环境保护的主题完美结合。',
    isHot: false,
    isNew: true,
    views: 3450000,
  },
  {
    id: 'v-20',
    title: '地球脉动·中国篇',
    categorySlug: 'documentary',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20nature%20documentary%20poster%20with%20snow%20leopard%20on%20Tibetan%20plateau%2C%20majestic%20mountain%20landscape%2C%20golden%20hour%20light%2C%20breathtaking%20natural%20beauty%2C%20clean%20title%20space&width=800&height=1120&seq=movie-doc-01&orientation=portrait',
    year: 2025,
    duration: '6集',
    rating: 9.7,
    description: '从青藏高原到南海岛礁，从东北雪原到云南雨林，用最先进的拍摄技术记录中国大地上令人叹为观止的自然奇观和野生动物。',
    isHot: true,
    isNew: true,
    views: 1230000,
  },
];